/* =============================================================================
   Hide the "[Reviews]" / "[Q&A]" headings when the widget under them is empty.

   Both Yotpo widgets render client-side, and with nothing to show they still
   mount: the reviews widget drops an empty .yotpo-base-layout, the Q&A widget an
   empty .yotpo-main-layout — a shell of comment placeholders that lays out at
   zero height. So the widget sections cost nothing on an accessory page; what
   was left stranded were the two headings, separate custom-liquid sections above
   them, each holding a headline over its own 80px of air and no content.

   Only the headings are touched. The widget sections stay in flow deliberately:
   display:none takes an element out of the intersection Yotpo mounts on, so
   collapsing them would stop a product WITH reviews from ever rendering them.

   Rendered height is the signal, not Yotpo's class names — the two widgets ship
   different empty markup and those internals change between Yotpo releases,
   while "the widget drew nothing" stays true.

   The watcher is a MutationObserver rather than a ResizeObserver: Yotpo mounts
   on its own schedule and can re-render (filters, pagination) long after load,
   and mutations are delivered on the microtask queue, where resize observations
   are tied to the frame loop and never arrive in a headless/backgrounded tab.
   The trailing re-measure covers the one case a mutation can't: markup landing
   before the stylesheet that gives it height.

   Fail-safe by construction: the hiding classes are added by this file, not by
   the stylesheet. If the script is blocked or throws, both headings stay visible
   and the page behaves exactly as it did before.
   ============================================================================= */
(function () {
  var HIDDEN = 'bss-yt-empty';   /* on a heading section whose widget is empty */
  var NONE = 'bss-yt-none';      /* on <html> when every heading collapsed */

  /* The heading is the section immediately before the widget's own section —
     that pairing is set by the template's section order, and only the two
     rebuilt heading sections carry .bss-widget-head. Templates without them
     (the legacy product.json, the no-buy template) have nothing to hide, and
     leave `pairs` empty so the document flag below never fires either. */
  function headingFor(section) {
    var prev = section.previousElementSibling;
    while (prev && !prev.classList.contains('shopify-section')) {
      prev = prev.previousElementSibling;
    }
    return prev && prev.querySelector('.bss-widget-head') ? prev : null;
  }

  var pairs = [];
  [].forEach.call(document.querySelectorAll('.yotpo-widget-instance'), function (widget) {
    var section = widget.closest('.shopify-section');
    var heading = section && headingFor(section);
    if (heading) pairs.push({ widget: widget, heading: heading });
  });
  if (!pairs.length) return;

  var pending = null;

  function measure() {
    pending = null;
    var allEmpty = true;
    pairs.forEach(function (pair) {
      var empty = pair.widget.getBoundingClientRect().height < 1;
      pair.heading.classList.toggle(HIDDEN, empty);
      if (!empty) allEmpty = false;
    });
    /* With both bands collapsed the story's closing hairline and the Discord
       band's opening one end up 120px apart with nothing between them — two
       rules bracketing empty space. The story's rule already draws that edge,
       so the Discord band drops its own (and the 56px it used to clear it). */
    document.documentElement.classList.toggle(NONE, allEmpty);
  }

  /* Yotpo mounts in bursts of mutations; one measure per burst is enough. */
  function schedule() {
    if (pending === null) pending = setTimeout(measure, 50);
  }

  /* Hidden up front so a headline never paints over a band that is about to
     collapse; the first measure below restores anything with content. */
  pairs.forEach(function (pair) { pair.heading.classList.add(HIDDEN); });
  document.documentElement.classList.add(NONE);

  pairs.forEach(function (pair) {
    new MutationObserver(schedule).observe(pair.widget, { childList: true, subtree: true });
  });
  measure();
  window.addEventListener('load', schedule);
  setTimeout(measure, 4000);
})();
